import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-100 pt-16 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="rounded-2xl bg-background-50 border border-background-200/60 p-8 md:p-12 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {}
            <div className="md:col-span-1">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-xl font-bold text-foreground-900 tracking-tight">
                  Kakobuy<span className="text-primary-500">Finds</span>
                </span>
              </Link>
              <p className="text-foreground-500 text-sm leading-relaxed">
                Największe centrum wiedzy o Kakobuy Spreadsheet, listach produktów i inteligentnym wyszukiwaniu najlepszych okazji. Niezależny serwis informacyjny.
              </p>
            </div>

            {}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Nawigacja</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Strona główna</Link></li>
                <li><a href="#kategorie" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Kategorie</a></li>
                <li><Link to="/artykul/kakobuy-sheet-kompletny-przewodnik" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Przewodnik</Link></li>
                <li><a href="#faq" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">FAQ</a></li>
              </ul>
            </div>

            {}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Arkusze</h4>
              <ul className="space-y-2.5">
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Kakobuy Spreadsheet</a></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">CSSBuy Spreadsheet</a></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Superbuy Spreadsheet</a></li>
                <li><a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Oopbuy Spreadsheet</a></li>
              </ul>
            </div>

            {}
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">Popularne kategorie</h4>
              <ul className="space-y-2.5">
                <li><a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Buty</a></li>
                <li><a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Bluzy/Swetry</a></li>
                <li><a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">T-Shirty</a></li>
                <li><a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-foreground-700 hover:text-primary-500 text-sm transition-colors duration-150 cursor-pointer">Torby</a></li>
              </ul>
            </div>
          </div>
        </div>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-secondary-200">
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <span>&copy; {currentYear} KakobuyFinds. Wszelkie prawa zastrzeżone.</span>
            <span className="hidden sm:inline text-foreground-300">|</span>
            <span>Niezależny serwis informacyjny.</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center hover:bg-primary-100 transition-colors duration-200 cursor-pointer">
              <i className="ri-shopping-bag-line text-foreground-700 text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center hover:bg-primary-100 transition-colors duration-200 cursor-pointer">
              <i className="ri-external-link-line text-foreground-700 text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}